import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import { importJWK, SignJWT } from 'jose';

const kbotJwk = {
    n: "m5Ey_uoEEly-YaSfmO9rMb4QPRevktKuY6SjVowkLBDv0niyBd_s0ul5sCTIzzJiE5G1-scBi5y1jZLSg8xU7c7Hn1Tn_nYRJx5NY7PeezACOtoyZ_An1nHorj4FXc6FwdxYSksf-Q8HN873YCsL7-aInpcok8Icc0bmAsHKiQzHLyAQWbypGe0l1tHtLeHpmjd9UGBNlyIIAi3vjUjDLJRvSKytByxTivVSTYcIhYS6To_aWR88-wrsXJBlRqccpjkR6bOeUm6uajeUhzypPZv7MEttaTz_fMgbr_dB5pamoJAouXhyjJL0ONwGtcVp8oMw_ylb-YoNyurmkWR49w",
    e: "AQAB",
    d: "LBHKff9CLwd54URW9-afGcTLadsbYD7xqwWZRevGVXtozNlnKRXhy2_biqQpBNUzhnKpOEUG8YtvvQ7iNvb7-jAxSbguTl4ZBtllOADc3k3f29czH1Gfn3a-YRntwEDAkIYAtu8oPBBfTZaCaopXQ9stSavtkUoUcC2d_Br06rS0PYHnrPXYzgu1lEG7_NNlUnEHYw0rUD9pASsh2oO3I18o1rVwzKhfxPNIP3kO9SQ5Nz1gH7jM2tuEoryYfnfbB7gssjDZJXzYojhxCqYFMmBNs9tufIxa35Q4SUknWmYa9018SGKp06xUKC_fAjWfGBGgXr978kFWdr5K33ccrQ",
    p: "0tf5-mTGAEPFkX6W03fkdf_910SnBCuFbZP9rGyYiIg1RaDLtDmJrTZHzL2h3SwKQ4Omy_PGoTWzqVp6EgeJ7wnfM6CLoR_NmUdCYMqV30EBgzAfQiXlL-FcYNq2ltYVk2LLZrUiY9uduQfb9imOliQvrh72JubvvdvLNhZKFRU",
    q: "vOKNwYdR4Inr_Q8VK513x196qMgknY_k-nL8NxvJEyRplZWQKUb2Z7zqSYVs0578fxZUAXejZ-wHF6320GiX6gskmj0jcqQerZuRvsU07adIqhD-SANwo6DBgZoEDL7Br3qgiG-Pb_0iGl-SgFWLuqNs8GPPsjmyl3hq4RjusNs",
    dp: "lTgBVPLpJtrQAo6i0_rwF4sa7bVKtqrOfaTVTah1s3siqKqKQHzQMWRPIFm9Kri2ct3DuGhI1WMaSescpZHsTt6ftvwSle_aJHbIRZRayWxKU7xFAx2qvF40cN-Zhdrx3iN3bLMZKa8OSxuC0w7KOPxXOlXzQ8kBN09M3HSd7Zk",
    dq: "epuhIsehGVzN58Vbm6UqtCtBJsBMLE7UdtIe7_LEUf2n3-Zm3rRmjC4v8qt-Wdvw0NoAi7dKRdILRI6zENNkERNMniYjlW39T_oU4D2Ivt-ApoxDUyGQg1Z9ZZBBIrjMZwj1nbq05B_vfCkfothkzDD7LQvNLUaQrAwJbLZPclM",
    qi: "JPRS1BTGWJ83lFHtpzt43L5ZoFVk0ah0JocOKFbo-0vhAn2p1V196c3rLagP1I2MMsz8CTo4YqYh4XvQz5gm7hiwypeMhf2MyeF3v2cbMNlh_MuKNYl_cfG742MvvXK6e7qeQjkB1tsJqt35B0wj69GXlMFBvxUZITjGmK8C5Nw",
    kty: "RSA"
};

export const createKbotToken = async (userId) => {
    const now = new Date(new Date().getTime() - 10000);
    const expNow = new Date(now.getTime() + 24 * 60 * 60 * 1000);
    const key = await importJWK(kbotJwk, 'RS256');
    const jwt = new SignJWT({
        email: "kdc_" + userId,
        dsn: 'kdc',
    })
        .setProtectedHeader({ alg: 'RS256' })
        .setExpirationTime(expNow)
        .setNotBefore(now)
        .setIssuedAt(now)
        .setIssuer('kdc');

    return await jwt.sign(key);
};

const Kbot = (props) => {
    const LoginStates = useSelector(state => state.login);
    const [kbotToken, setkbotToken] = useState('');
    const [pipeline, setPipeline] = useState(null);
    const attachListenerRef = useRef(null);
    const attachFallbackTimerRef = useRef(null);
    const isMountedRef = useRef(false);
    const targetModelName = "KDC-librarian";

    const normalizeModelName = (modelName) => {
        return String(modelName ?? '').toLowerCase().replace(/[^a-z0-9]/g, '');
    };

    const getModelName = (model) => {
        if (typeof model === 'string') return model;
        return model?.id ?? model?.name ?? model?.model ?? model?.value ?? '';
    };

    const resolveKbotModelName = (availableModels) => {
        if (!Array.isArray(availableModels)) return targetModelName;

        const target = normalizeModelName(targetModelName);
        const candidates = availableModels
            .map(getModelName)
            .filter(Boolean);

        return candidates.find(model => normalizeModelName(model) === target)
            ?? candidates.find(model => normalizeModelName(model).includes(target))
            ?? candidates.find(model => target.includes(normalizeModelName(model)))
            ?? candidates.find(model => {
                const normalized = normalizeModelName(model);
                return normalized.includes('kdc') && normalized.includes('librarian');
            })
            ?? null;
    };

    const getKbotOrigin = () => {
        if (!props.kbotUrl) return '*';
        return new URL(props.kbotUrl).origin;
    }

    const isKbotMessage = (event) => {
        const kbotOrigin = getKbotOrigin();
        return kbotOrigin === '*' || event.origin === kbotOrigin;
    };

    const getKbotClient = async () => {
        if (window.aimaWebuiPipelineClient) {
            return window.aimaWebuiPipelineClient;
        }

        await new Promise((resolve, reject) => {
            const script = document.querySelector('script[data-kbot-pipeline-client="true"]');
            if (script) {
                script.addEventListener('load', resolve, { once: true });
                script.addEventListener('error', reject, { once: true });
                return;
            }

            const newScript = document.createElement('script');
            newScript.src = 'https://api.ksystemace.com/external/static/dist/@aima/webui-pipeline-client/0.1.6/bundle.iife.min.js';
            newScript.crossOrigin = 'anonymous';
            newScript.integrity = 'sha384-4hAb+pIrU0a7jYlZzfz3lDKr/HuepC1Y8nK9sl1mblNqS7/ag+t7JznG3TQGRuWj';
            newScript.defer = true;
            newScript.dataset.kbotPipelineClient = 'true';
            newScript.addEventListener('load', resolve, { once: true });
            newScript.addEventListener('error', reject, { once: true });
            document.head.appendChild(newScript);
        });

        if (!window.aimaWebuiPipelineClient) {
            throw new Error('aimaWebuiPipelineClient was not loaded.');
        }

        return window.aimaWebuiPipelineClient;
    };

    // iframe 메시지 리스너
    useEffect(() => {
        if(!pipeline || !props.kbotUrl) return;
        const handleMessage = (event) => {
            if (!isKbotMessage(event)) {
                return;
            }

            const messageName = event.data?.fn || event.data?.key;
            if(messageName === "login" && event.data?.state?.is_success) {
                setKbotDefaultModel();
            }

            if(messageName === "attach" && event.data?.state?.status === "loaded") {
                setKbotDefaultModel();
            }
        };
        window.addEventListener("message", handleMessage);
        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, [pipeline, props.kbotUrl]);

    // attach status가 loaded가 된 뒤 모델을 다시 지정한다.
    useEffect(() => {
        if (!pipeline) return;
        const client = window.aimaWebuiPipelineClient;
        if (!client?.utils?.pipeline?.createListener) return;

        const attachListener = client.utils.pipeline.createListener(
            async (state) => {
                if (state?.key !== "attach" || state?.from !== "server") return;
                if (state?.state?.status === "login" || state?.state?.status === "loaded") {
                    await setKbotDefaultModel();
                }
            },
            {
                uid: `kbot_attach_status_listener:${pipeline.id}`,
                once: false
            }
        );

        attachListenerRef.current = attachListener;
        pipeline.strict_producer.subscribe(attachListener);

        return () => {
            attachListener.dispose();
            if (attachListenerRef.current === attachListener) {
                attachListenerRef.current = null;
            }
        };
    }, [pipeline]);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    useEffect(() => {
        if (LoginStates.userId && props.kbotUrl)
            createToken();
    }, [LoginStates, props.kbotUrl]);

    // pipeline 생성 및 attach
    useEffect(() => {
        const rootElement = document.getElementById('root');
        let disposed = false;

        const createPipeline = async () => {
            try {
                const client = await getKbotClient();
                if (disposed || !isMountedRef.current) return;

                const pipelineObj = await client.pipeline.Pipeline.create("kbot");
                pipelineObj.frame_src = props.kbotUrl;
                await pipelineObj.attach(window);

                if (disposed || !isMountedRef.current) {
                    await pipelineObj.detachIframe?.();
                    return;
                }

                setPipeline(pipelineObj);
                rootElement?.classList.add('kbot');
            } catch (error) {
                console.error('Failed to initialize kbot pipeline:', error);
            }
        };

        if (props.on) {
            createPipeline();
        } else {
            rootElement?.classList.remove('kbot');
            if (pipeline) {
                pipeline.detachIframe?.();
            }
            setPipeline(null);
        }
        // cleanup
        return () => {
            disposed = true;
            if (attachListenerRef.current) {
                attachListenerRef.current.dispose();
                attachListenerRef.current = null;
            }
            if (attachFallbackTimerRef.current) {
                clearTimeout(attachFallbackTimerRef.current);
                attachFallbackTimerRef.current = null;
            }
        };
    }, [props.on]);

    // attach 리스너 등록 및 iframe 연결
    useEffect(() => {
        if (pipeline && kbotToken) {
            if (attachFallbackTimerRef.current) {
                clearTimeout(attachFallbackTimerRef.current);
                attachFallbackTimerRef.current = null;
            }

            const attachAndLogin = async () => {
                try {
                    await pipeline.attachIframe({
                        options: {
                            id: "kbot-iframe",
                            title: "Kbot Iframe",
                            allow: "microphone",
                            width: "100%",
                            height: "100%",
                            wait_attach_message: true,
                            wait_attach_timeout: 10000
                        },
                    });

                    await loginToKbot(kbotToken);
                } catch (error) {
                    console.error('Failed to attach/login kbot iframe:', error);
                }
            };

            attachAndLogin();

            attachFallbackTimerRef.current = setTimeout(() => {
                loginToKbot(kbotToken);
            }, 1000);
        }
    }, [pipeline, kbotToken, props.kbotUrl]);

    // JWT 토큰 생성 함수
    const createToken = async () => {
        const token = await createKbotToken(LoginStates.userId);
        setkbotToken(token);
    };

    // v0.1.6 방식의 pipeline 로그인 요청 함수
    const loginToKbot = async (jwtToken) => {
        if (!pipeline) return;
        await pipeline.runFeature("login", {
            api_version: 2,
            token: jwtToken
        });

        setTimeout(() => {
            setKbotDefaultModel();
        }, 500);
        setTimeout(() => {
            setKbotDefaultModel();
        }, 1500);
        setTimeout(() => {
            setKbotDefaultModel();
        }, 3000);
    };

    // v0.1.6 기준 모델 지정 feature
    const setKbotDefaultModel = async () => {
        if (!pipeline) return;
        try {
            const before = await pipeline.callFeature(
                {
                    key: "settings",
                    state: {
                        op: "get",
                        values: [
                            "model.current",
                            "model.available"
                        ]
                    }
                },
                { timeout: 5000 }
            );
            const available = before?.state?.values?.find(value => value.path === "model.available")?.value;
            const selectedModel = resolveKbotModelName(available);

            if (!selectedModel) {
                console.warn(`Kbot model '${targetModelName}' was not found in available models:`, available);
                return;
            }

            if (selectedModel !== targetModelName) {
                console.info(`Kbot model '${targetModelName}' resolved to '${selectedModel}'.`);
            }

            const response = await pipeline.callFeature(
                {
                    key: "settings",
                    state: {
                        op: "set",
                        values: [
                            {
                                path: "model.current",
                                value: selectedModel
                            }
                        ]
                    }
                },
                { timeout: 5000 }
            );
            console.info("Kbot model setting response:", response?.state);
        } catch (error) {
            console.warn("Kbot model setting failed.", error);
        }
    };

    return (
        <div id="kbot" className="kbot-wrap" style={{ display: props.on ? 'block' : 'none' }}>
            <button className="btn-close" style={{ position: "absolute", right: "7px", top: "12px", background: "transparent" }} onClick={() => { props.setKbotFrame(false) }}>
                <i className="icoKdc32 close" style={{ background: "transparent" }}></i>
            </button>
            {/* iframe은 pipeline.attach_iframe에서 동적으로 생성 */}
        </div>
    );
};

export default Kbot;
